import React from "react";
import { Container } from "react-bootstrap";
import logo from "../assets/img/logo_t4a_white.svg";
import logo_text from "../assets/img/logo_t4a_text_white.svg";
import "../css/Home.css";
import "../css/react-image-gallery.css";
import CardCommunityProgress from "./CardCommunityProgress";
import CardHSPUProgram from "./CardHSPUProgram";
import ProfilePage from "./ProfilePage";
import data_user from '../data/data_user';
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { HiChevronDown } from "react-icons/hi";

function Home() {
  const video_row_1 =
    "https://t4abucket225336-staging.s3.us-east-2.amazonaws.com/video_handstandpu.mp4";
  const video_row_2 =
    "https://t4abucket225336-staging.s3.us-east-2.amazonaws.com/video_run.mp4";
  // const video_row_3 =
  //  "https://t4abucket225336-staging.s3.us-east-2.amazonaws.com/video_pu.mp4";
  const video_row_4 =
    "https://t4abucket225336-staging.s3.us-east-2.amazonaws.com/videos_rope.mp4";
  const video_row_5 =
    "https://t4abucket225336-staging.s3.us-east-2.amazonaws.com/video_pullups.mp4";



  return (
    <div className="page home">
      <Helmet>
        <title>thenics4all</title>
        <meta
          name="description"
          content="Step-by-step Handstand pushup progressions, training and tutorials."
        />
        <meta
          name="keywords"
          content="handstand, handstand pushup, hspu, calisthenics, progression, tutorial"
        />
      </Helmet>

      <Container fluid>
        {/************** Row 1 ****************/}

        <div className="home-row row-1">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="home-row-video-background"
          >
            <source src={video_row_1} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <img className="home-logo-text" src={logo_text} alt="thenics4all" />
          <img className="home-logo" src={logo} alt="Logo" />
          <h2 className="home-row-subtitle row-1">Unlock Impossible!</h2>
          {/* Animated Down Arrow */}
          <motion.div
            className="scroll-arrow"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1 }}
          >
            <a href="#program" className="arrow-link">
              <motion.div
                animate={{ y: [0, 10, 0] }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                <HiChevronDown className="arrow-icon" />
              </motion.div>
            </a>
          </motion.div>
        </div>
        <hr className="home-horizontal-rule" />

        {/************** Row  2 ****************/}

        <div className="home-row row-program" id="program">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="home-row-video-background"
          >
            <source src={video_row_2} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h1>
            <a className="home-link" href="/program">
              Program
            </a>
          </h1>
          <h2 className="home-row-subtitle">
            Explore our program - 6 levels to learn the Handstand Pushup
          </h2>
          <CardHSPUProgram />
        </div>
        <hr className="home-horizontal-rule" />

        {/************** Row  3 Train ***************

        <div className="home-row row-train">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="home-row-video-background"
          >
            <source src={video_row_3} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h1>
            <a className="home-link" href="/train">
              Train
            </a>
          </h1>
          <h2 className="home-row-subtitle">The first step toward success is failure.</h2>
          <CardHSPUTrain />
        </div>
        <hr className="home-horizontal-rule" />
        */}

        {/************** Row  4 Progress ****************/}

        <div className="home-row">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="home-row-video-background"
          >
            <source src={video_row_4} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h1>
            <a className="home-link" href="/progress">
              Progress
            </a>
          </h1>
          <h2 className="home-row-subtitle">
            <a className="home-link-join" href="/login">Join</a> to create your own profile and log progress</h2>
          <ProfilePage />
        </div>
        <hr className="home-horizontal-rule" />

        {/************** Row  5 Community ****************/}

        <div className="home-row">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="home-row-video-background"
          >
            <source src={video_row_5} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <h1>
            <a className="home-link" href="/community">
              Community
            </a>
          </h1>
          <h2 className="home-row-subtitle">Check out progress and uploads from the community</h2>
          <CardCommunityProgress data_user={data_user} />
        </div>
        <hr className="home-horizontal-rule" />

        {/************** End Row  ****************/}

      </Container>
    </div>
  );
}

export default Home;
